// extracted by mini-css-extract-plugin
export default {"container":"Gpan8c"};